import { forwardRef } from 'react';
import { Collapse as MuiCollapse, CollapseProps as MuiCollapseProps } from '@mui/material';

export type CollapseProps = MuiCollapseProps;

export const Collapse = forwardRef<HTMLDivElement, CollapseProps>((props, ref) => (
  <MuiCollapse ref={ref} {...props} />
));

Collapse.displayName = 'Collapse';
